import { Component, EventEmitter, OnDestroy, Output, inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from "@angular/forms"
import { PATTERNS } from "src/app/meta/patterns.const"
import { CustomerDataService } from "src/app/services/customer-data.service"

@Component({
    selector: "ow-customer-promo-form",
    templateUrl: "./customer-promo-form.component.html"
})
export class CustomerPromoFormComponent implements OnInit, OnDestroy {
  
    @Output() updateValidity = new EventEmitter<boolean>(false)

    private readonly customerDataService = inject(CustomerDataService)

    public readonly form = new FormGroup({
        promoCustomerNumber: new FormControl<string>(this.customerDataService.getContactData().promoCustomerNumber, [Validators.pattern(PATTERNS.PROMO_CUSTOMER_NUMBER)]),
    })

    private readonly subscriptions = [
        this.form.controls.promoCustomerNumber.valueChanges.subscribe((value) => {
            if (this.form.controls.promoCustomerNumber.valid) {
                this.customerDataService.setContactData({ promoCustomerNumber: value! })
            }
        }),
        this.form.statusChanges.subscribe(() => {
            this.updateValidity.emit(this.form.valid)
        })
    ]

    ngOnInit(): void {
        this.form.controls.promoCustomerNumber.updateValueAndValidity()
        this.updateValidity.emit(this.form.valid)
      }
    
    ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => {
            subscription.unsubscribe()
        })
    }
  
}
